import React, { useContext, useReducer } from "react";

const recorderContext = React.createContext();

const initialValue = {
  isRecording: false,
  isClipPlaying: false,
};

const reducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case "RECORDER_STAT":
      return {
        ...state,
        isRecording: payload,
      };
    case "AUDIO_CLIP_STAT":
      return {
        ...state,
        isClipPlaying: payload,
      };
    case "RESET_STAT":
      return { ...initialValue };

    default:
      return state;
  }
};

export function RecorderProvider(props) {
  const [recorderC, dispatchRecorder] = useReducer(reducer, initialValue);
  return (
    <recorderContext.Provider
      value={{ recorderC, dispatchRecorder }}
      {...props}
    />
  );
}

export function RecorderContext() {
  const context = useContext(recorderContext);
  if (!context) {
    throw new Error(" Please use the context inside parent scope");
  }
  return context;
}
